/* RS Air Filter — menu mobile (toggle robusto: bind direto + delegação + touch, sem inline p/ CSP) */
(function () {
  var root = document.documentElement;
  function open(e) { if (e) e.preventDefault(); root.classList.add('rs-mnav-open'); }
  function close(e) { if (e) e.preventDefault(); root.classList.remove('rs-mnav-open'); }

  function bind() {
    document.querySelectorAll('[data-rs-menu-open]').forEach(function (el) {
      if (el.__rsBound) return; el.__rsBound = 1;
      el.addEventListener('click', open);
      el.addEventListener('touchend', open, { passive: false });
    });
    document.querySelectorAll('[data-rs-menu-close]').forEach(function (el) {
      if (el.__rsBound) return; el.__rsBound = 1;
      el.addEventListener('click', close);
      el.addEventListener('touchend', close, { passive: false });
    });
  }

  /* Delegação (rede de segurança p/ re-render do editor) */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-rs-menu-open]')) open(e);
    else if (e.target.closest('[data-rs-menu-close]')) close(e);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();
